module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jQsWU"))).then(() => parcelRequire('9Lwss'));